import React, { useState, useEffect } from 'react'
import { CircularProgress, Paper, Grid, FormControl, InputLabel, Select, MenuItem, TextField, InputAdornment,
     Snackbar, TableContainer, TableRow, TableCell, TableHead, Table, TableBody, Switch} from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search';
import './FarolPage.css'
import { updateTrainingUser } from '../../pages/Training/_redux/TrainingCrud'
import AlertHelper from '../../components/Alert';
import { apiGETFunil, apiGETUsers, apiGETFunilList } from './actions'
import { getMyApprovalsAPI } from '../../pages/ApprovalFlow/_redux/ApprovalCrud';
import { getUserAccessLevel } from "../../helpers/role";
import { getUserId, getUserFactoryId} from '../../../index';
import _ from 'lodash'
import BackButton from '../../components/BackButton/BackButton'
import { Badge, Button } from 'react-bootstrap'

const activityClassification = [
    {
        name: "Todos",
        value:0
    },
    {
        name: "Elétrica",
        value: 1
    },
    {
        name: "Eletrônica",
        value: 2
    },
    {
        name: "Fixação",
        value: 3
    },
    {
        name: "Hidráulica",
        value: 4
    },
    {
        name: "Instrumentação",
        value: 5
    },
    {
        name: "Lubrificação",
        value: 6
    },
    {
        name: "Outras",
        value: 7
    },
    {
        name: "Pneumática",
        value: 8
    },
    {
        name: "Transmissão",
        value: 9
    },
    {
        name: "Troca",
        value: 10
    }
]

export default function FarolPage(props) {
    const [isSaving, setIsSaving] = useState(false);
    const [array, setArray] = useState([1, 2, 3, 4, 5])
    const [users, setUsers] = useState([])
    const [filter10, setFilter10] = useState(10)
    const [filter20, setFilter20] = useState(10)
    const [filter202, setFilter202] = useState(10)
    const [filter70, setFilter70] = useState(10)
    const [nameFilter, setNameFilter] = useState('')
    const [atividades, setAtividades] = useState([])
    const [atividadesFiltered, setAtividadesFiltered] = useState([])
    const [funil, setFunil] = useState([])
    const [selectAct, setSelectAct] = useState(0)
    const [selectFunil, setSelectFunil] = useState(0)
    const [change, set] = useState(0)
    const [filter, setFilter] = useState([])
    const [authorId, setAuthorId] = useState(0)
    const [filterActivityClassification, setFilterActivityClassification] = useState({
        name: "Todos",
        value: 0
    })
    const [farolEditor, setFarolEditor] = useState(false)
    const [listaFunis, setListaFunis] = useState([])

    const [snackBar, setSnackBar] = useState({
        isOpen: false,
        message: '',
        vertical: 'top',
        horizontal: 'right',
        type: 'error'
    });

    useEffect(() => {

        async function getFarol() {
            const listaFunil = await apiGETFunilList();
            setListaFunis(listaFunil.value);

            const funnelId = (props.match.params.id)
            const activityParam = (props.match.params.activityId)
            if (funnelId != 0) {
                GetFunnelData(funnelId, activityParam)
            }
            else {
                if (listaFunil.value.length > 0) {
                    GetFunnelData(listaFunil.value[0].id)
                }
            }
        }

        function getUserProfile() {
            //request all factory approvers        
            getMyApprovalsAPI(getUserId(), getUserFactoryId()).then((res) => {
                if (res.status === 200 && res.data.value.length >= 1) {
                    res.data.value.forEach((item) => {
                        if (item.standardType == 'Funil' && item.standardClassification == 'Farol')                            
                            setFarolEditor(true);
                    })
                }
            }).catch(error => {
                setSnackBar({ ...snackBar, isOpen: true, message: 'Erro na coleta de dados de aprovadores, tente novamente!', type: 'error' })
                return false;
            });
        }

        getFarol()
        getUserProfile()

        if (getUserAccessLevel() >= 7)
            setFarolEditor(true);
    }, [])

    useEffect(() => {

        setFilterActivityClassification({
            name: "Todos",
            value: 0
        })

    }, [funil])

    async function GetFunnelData(funilId, activityParam = 0) {
        setSelectFunil(funilId)
        let fn = await apiGETFunil(funilId)
        setFunil(fn)
        if (activityParam == 0) {
            if (fn.funilActivities.length > 0)
                changeAct(fn.funilActivities[0].id, fn)
        }
        else {
            changeAct(activityParam, fn)
        }        
    }

    async function changeAct(activityParam, funnel = null) {
        setSelectAct(activityParam)
        setUsers([])
        setFilter([])
        let funilData;
        if (funnel == null)
            funilData = funil;
        else
            funilData = funnel;
        let activityList = funilData.funilActivities.filter((item) => {
            return item.id == activityParam
        });
        if (activityList.length === 0)
            return;
        let activityId = activityList[0].lppId != null ? activityList[0].lppId : 0;
        if(activityId == 0)
            activityId = activityList[0].dtpId != null ? activityList[0].dtpId : 0;
        if (activityId === 0) {
            setUsers([])
            setFilter([])
            return;
        }
        let us = await apiGETUsers(activityId)
        if (us.length < 1) {
            setUsers([])
            setFilter([])
            return;
        }
        else {
            console.log(us)
            setAuthorId(us[0].standard.userId)
        }
        setUsers(us)
        setFilter(us)
    }

    async function changeFunil(funilId) {    
        GetFunnelData(funilId);
    }

    function filtrar() {
        let aux = users.filter(e => e.user.name.toUpperCase().includes(nameFilter.toUpperCase()) === true)
        if (filter10 !== 10) {
            const comparison = filter10 == 20;
            aux = aux.filter(e => e.status === comparison)
        }
        if (filter20 !== 10) {
            const comparison = filter20 == 20;
            aux = aux.filter(e => e.farolLvl20 === comparison)
        }
        if (filter202 !== 10) {
            const comparison = filter202 == 20;
            aux = aux.filter(e => e.farolLvl202 === comparison)
        }
        if (filter70 !== 10) {
            const comparison = filter70 == 20;
            aux = aux.filter(e => e.farolLvl70 === comparison)
        }
        setFilter(aux);
        console.log(aux)
    }

    function limpar() {
        setFilter10(10)
        setFilter20(10)
        setFilter202(10)
        setFilter70(10)
        setNameFilter('')
        setFilter(users)
    }

    function handleChangeFilter(e, filterLevel) {
        switch (filterLevel) {
            case 'filter10':
                setFilter10(e.target.value)
                break;
            case 'filter20':
                setFilter20(e.target.value)
                break;
            case 'filter202':
                setFilter202(e.target.value)
                break;
            case 'filter70':
                setFilter70(e.target.value)
                break;
        }
    }

    function changeGap(check, gap, index) {
        setIsSaving(true);

        let indexUserArray = _.findIndex(users, function (o) { return o.userId === filter[index].userId });
        switch (gap) {                
            case '20':
                filter[index].farolLvl20 = check;
                users[indexUserArray].farolLvl20 = check;
                if (!check) {
                    filter[index].farolLvl202 = false;
                    users[indexUserArray].farolLvl202 = false;
                    filter[index].farolLvl70 = false;
                    users[indexUserArray].farolLvl70 = false;
                }
                break;
            case '202':
                filter[index].farolLvl202 = check;
                users[indexUserArray].farolLvl202 = check;
                if (!check) {
                    filter[index].farolLvl70 = false;
                    users[indexUserArray].farolLvl70 = false;
                }
                break;
            case '70':
                filter[index].farolLvl70 = check;
                users[indexUserArray].farolLvl70 = check;
                break;
            case 'isInFarol':
                filter[index].isInFarol = check;
                users[indexUserArray].isInFarol = check;
                break;
        }
        setFilter(filter);
        setUsers(users);
        set(change + 1)
        UpdateFarol(index);        
    }

    function getSwitch(el, i, farollvl) {
        let checked = false;
        let disabled= true;
        switch (farollvl) {
            case '20':
            default:
                if (!el.isInFarol)
                    return '';
                checked = el.farolLvl20
                disabled = !el.status || !farolEditor;
                break;
            case '202':
                if (!el.isInFarol)
                    return '';
                checked = el.farolLvl202
                disabled = !el.farolLvl20 || !farolEditor;
                break;
            case '70':
                if (!el.isInFarol)
                    return '';
                checked = el.farolLvl70
                disabled = !el.farolLvl202 || !farolEditor;
                break;
            case 'isInFarol':
                if (el.userId == authorId)
                    return (<Badge variant='info'>Autor</Badge>);
                checked = el.isInFarol
                disabled = !farolEditor;
                break;
        }


    return (
        
        <Switch
            checked={checked}
            onChange={(e) => changeGap(e.target.checked, farollvl, i)}
            color="primary"
            disabled={disabled}
            />
            
        )
    }

    async function UpdateFarol(index) {       

        let dataPost = JSON.parse(JSON.stringify(filter[index]));
        delete dataPost.user;
        delete dataPost.updatedAt;
        delete dataPost.standard;

        const result = updateTrainingUser(dataPost).then(() => {
            setIsSaving(false);
            return true;
        }).catch(error => {
            setSnackBar({ ...snackBar, isOpen: true, message: 'Erro ao atualizar farol, tente novamente!', type: 'error' })
            setIsSaving(false);
            return false;
        });

        return result;
    }

    const handleCloseSnackbar = async () => {
        setTimeout(function () {
            setSnackBar({ ...snackBar, isOpen: false, message: '' })
        }, 3000);
    }

    function handleChangeFilterActivityClassification(e) {
        
        const index = parseInt(e.target.value)
        const filter = activityClassification[index]
        setFilterActivityClassification(filter)

        setUsers([])
        setFilter([])
    }

    function getActivitiesFiltered(e, i) {
        if (filterActivityClassification.name == 'Todos')
            return <MenuItem key={i} value={e.id}>{e.activity}</MenuItem>
        if (e.classification == filterActivityClassification.name)
            return <MenuItem key={i} value={e.id}>{e.activity}</MenuItem>
    }

    return(
        <>
            <BackButton />
            <div><br/></div>

            <Snackbar
                open={snackBar.isOpen}
                anchorOrigin={{ vertical: snackBar.vertical, horizontal: snackBar.horizontal }}
                key={snackBar.vertical + snackBar.horizontal}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
            >
                <AlertHelper onClose={handleCloseSnackbar} severity={snackBar.type}>
                    {snackBar.message}
                </AlertHelper>
            </Snackbar>

            <h1>Farol 70/20/10</h1>

            <Paper className="PaperFarolAct">
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <label className='w-100'>
                            Funis
                        </label>
                        <FormControl className="inputFarolFilter">
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectFunil}
                                onChange={e => changeFunil(e.target.value)}
                                >
                                {
                                    listaFunis.map((e, i) => (
                                        <MenuItem key={i} value={e.id}>{e.structure.name}</MenuItem>
                                    ))
                                }

                            </Select>
                        </FormControl>
                    </Grid>                
                </Grid>
            </Paper>

        <Paper className="PaperFarolAct">
        <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
            <label className='w-100'>
                    Atividades
            </label>
            <FormControl className="inputFarolFilter">
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectAct}
              onChange={e => changeAct(e.target.value)}
            >
                {
                    (funil.funilActivities || []).map((e,i)=>(
                        getActivitiesFiltered(e,i)
                    ))
                }
          
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3}>
            <label className='w-100'>
                    Classificação
            </label>
            <FormControl className="inputFarolFilter">
            <Select
              fullWidth
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filterActivityClassification.value}
              onChange={handleChangeFilterActivityClassification}
                >
                    {
                        activityClassification.map((e, i) => (
                            <MenuItem key={i} value={e.value}>{e.name}</MenuItem>
                        ))
                    }
            </Select>
          </FormControl>
        </Grid>
        </Grid>
        </Paper>


        <Paper className="PaperFarol">
        <Grid spacing={2} container>
        <Grid item xs={12} sm={6}>
        <TextField
              value={nameFilter}
              onChange={(e) => setNameFilter(e.target.value)}
              fullWidth
              label="Pesquisar por nome"
              id="standard-start-adornment"
              InputProps={{
                startAdornment: <InputAdornment position="start"><SearchIcon/></InputAdornment>,
              }}
            />
        </Grid>
        <Grid item xs={12} sm={6} >
        <label className='w-100'>Filtrar por nível</label>
        {/* <div className="labelftNivel"> */}
        <Grid container spacing={2}>
        <Grid item xs={6} sm={2} >
        <label className='w-50 labelNivel'>
            <p style={{ color: 'green', fontWeight: 'bold' }}>10%</p>
            <FormControl className="inputFarolFilter">
                <Select
                  fullWidth
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={filter10}
                  onChange={(e)=>handleChangeFilter(e, 'filter10')}
                >
                  <MenuItem value={10} name={'-'}>-</MenuItem>
                  <MenuItem value={20} name={'Sim'}>Sim</MenuItem>
                  <MenuItem value={30} name={'Não'}>Não</MenuItem>
                </Select>
            </FormControl>
        </label>
        </Grid>
        <Grid item xs={6} sm={2} >
            <label className='w-50 labelNivel'>
            <p style={{ color: 'green', fontWeight: 'bold' }}>20%</p>
           <FormControl className="inputFarolFilter">
                <Select
                  fullWidth
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={filter20}
                  onChange={(e)=>handleChangeFilter(e, 'filter20')}
                >
                  <MenuItem value={10} name={'-'}>-</MenuItem>
                  <MenuItem value={20} name={'Sim'}>Sim</MenuItem>
                  <MenuItem value={30} name={'Não'}>Não</MenuItem>
                </Select>
            </FormControl>
            </label>
        </Grid>
        <Grid item xs={6} sm={2} >
            <label className='w-50 labelNivel'>
            <p style={{ color: 'green', fontWeight: 'bold' }}>20%</p>
           <FormControl className="inputFarolFilter">
                <Select
                  fullWidth
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={filter202}
                  onChange={(e)=>handleChangeFilter(e, 'filter202')}
                >
                  <MenuItem value={10} name={'-'}>-</MenuItem>
                  <MenuItem value={20} name={'Sim'}>Sim</MenuItem>
                  <MenuItem value={30} name={'Não'}>Não</MenuItem>
                </Select>
            </FormControl>
            </label>
        </Grid>
        <Grid item xs={6} sm={2} >
           <label className='w-50 labelNivel'>
               <p style={{ color: 'green', fontWeight: 'bold' }}>70%</p>
            <FormControl className="inputFarolFilter">
                <Select
                  fullWidth
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={filter70}
                  onChange={(e)=>handleChangeFilter(e, 'filter70')}
                >
                  <MenuItem value={10} name={'-'}>-</MenuItem>
                  <MenuItem value={20} name={'Sim'}>Sim</MenuItem>
                  <MenuItem value={30} name={'Não'}>Não</MenuItem>
                </Select>
            </FormControl>
            </label>
        </Grid>
        </Grid>
        {/* </div> */}
        </Grid>
        <Grid item xs={12}>
            <div className="btsFiltersFarol">
            <Button variant="danger" onClick={()=>limpar()} className='espaceinbuttons'> Limpar </Button>
            <Button variant="success" onClick={()=>filtrar()}> Filtrar </Button>
            </div>
        </Grid>
        </Grid>
        </Paper>

        { users.length < 1 ? 'Nenhum colaborador apontado para treinamento nesta atividade' : 
        <Paper style={{marginTop: '15px'}}>
            <TableContainer>
                <Table>
                    <TableHead>
                    <TableRow>
                        <TableCell>
                            Nome
                        </TableCell>
                        <TableCell>
                            Sap
                        </TableCell>
                        <TableCell>
                            Departamento
                        </TableCell>
                        <TableCell>
                            Grupo de função
                        </TableCell>
                        <TableCell>
                            Faz parte do Farol?
                        </TableCell>
                        <TableCell className="cellSwitch">
                                    <p style={{ color: 'green', fontWeight: 'bold' }}>10%</p>
                                    Treinado
                        </TableCell>
                        <TableCell className="cellSwitch">                                
                                    <p style={{ color: 'green', fontWeight: 'bold' }}>20%</p>
                                    Observou
                        </TableCell>
                        <TableCell className="cellSwitch">
                                    <p style={{ color: 'green', fontWeight: 'bold' }}>20%</p>
                                    Fez acompanhado
                        </TableCell>
                        <TableCell className="cellSwitch">
                                    <p style={{ color: 'green', fontWeight: 'bold' }}>70%</p>
                                    Fez sozinho
                        </TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                    filter.map((el, i)=>(
                        <TableRow key={i}>
                        <TableCell>
                            {el.user.name}
                        </TableCell>
                        <TableCell>
                           {el.user.sap}
                        </TableCell>
                        <TableCell>
                        {el.user.deparment ? el.user.deparment.name : 'Departamento inválido'} 
                        </TableCell>
                        <TableCell>
                        {el.user.companyRole.name.substr(0, el.user.companyRole.name.indexOf(" "))}
                            </TableCell>
                            <TableCell className="cellSwitch">
                                {getSwitch(el, i, 'isInFarol')}
                            </TableCell>
                            
                            <TableCell className="cellSwitch">
                            {el.isInFarol ?
                                <Switch
                                    checked={el.status}
                                    disabled={true}
                                    color="primary"
                                />
                                :
                                ''
                                }
                            </TableCell>
                                
                        <TableCell className="cellSwitch">
                                {getSwitch(el,i, '20')}
                        </TableCell>
                        <TableCell className="cellSwitch">
                               { getSwitch(el, i, '202') }
                        </TableCell>
                        <TableCell className="cellSwitch">
                                {getSwitch(el, i, '70')}
                        </TableCell>
                    </TableRow>    
                        ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>

                </Paper>
            }
            {isSaving &&
                <div className='w-100 text-center mx-auto'>
                    <CircularProgress />
                </div>
            }
        </>
)
}